"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinksAndLegalTags = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const LegalTags_molecule_1 = require("../legal/LegalTags.molecule");
const Newsletter_organism_1 = require("../newsletter/Newsletter.organism");
const Links_molecule_1 = require("./Links.molecule");
const classnames_1 = __importDefault(require("classnames"));
const Styled = styled_components_1.default.div `
    display: flex;
    justify-content: space-between;

    &.ar {
        direction: rtl;
    }

    ${(p) => p.theme.breakpoints.down('sm')} {
        display: block;
    }

    .news-legal-wrap {
        display: flex;
        flex-direction: column;
        align-content: center;
        justify-content: center;
        align-items: flex-end;

        ${(p) => p.theme.breakpoints.down('sm')} {
            align-items: center;
        }
    }
`;
const LinksAndLegalTags = (props) => {
    const legalTags = props.legalTags || [];
    const locale = props.locale || '';
    return (react_1.default.createElement(Styled, { className: (0, classnames_1.default)('links-legal-tags', locale) },
        react_1.default.createElement("div", { className: "links-wrap" },
            react_1.default.createElement(Links_molecule_1.Links, Object.assign({}, props, { locale: locale }))),
        react_1.default.createElement("div", { className: "legal-tags-wrap" },
            react_1.default.createElement("div", { className: "news-legal-wrap" },
                react_1.default.createElement(Newsletter_organism_1.Newsletter, Object.assign({}, props)),
                react_1.default.createElement(LegalTags_molecule_1.LegalTags, { legalTags: legalTags })))));
};
exports.LinksAndLegalTags = LinksAndLegalTags;
//# sourceMappingURL=LinksAndLegalTags.molecule.js.map